import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';

@Component({
    selector: 'branchexcellenceadmin',
    templateUrl: './branchexcellenceadmin.component.html',
    styleUrls: ['./branchexcellenceadmin.component.less', '../../../../style/container-tab-list.component.less'],
    standalone: false
})
export class BranchExcellenceAdminComponent implements OnInit {

    @ViewChild('tabGroup') tabGroup!: MatTabGroup;
    selectedWave: Wave;
    constructor(
        public defaults: DefaultValuesService
    ) {
        this.selectedWave = {
            WaveId: -1,
            Name: '',
            ChangedBy: ''
        }
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        this.defaults.defaultComponentTab(this)
    }

    onSelectedWave(wave: any) {
        this.selectedWave = wave
    }

}
